import { useEffect } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import ErrorToast from "@/components/ErrorToast/ErrorToast"
import FacilitatorOnly from "@/routes/FacilitatorOnly"
import { ROUTES } from "@/routes/routes"
import { startAuth } from "@/store/authSync"
import ArchivePage from "@/pages/Archive/ArchivePage"
import CustomerList from "@/pages/CustomerList/CustomerList"
import CustomerDetails from "@/pages/CustomerDetails/CustomerDetails"
import DeckPage from "@/pages/DeckPage/DeckPage"
import DeckPreviewPage from "@/pages/DeckPreview/DeckPreviewPage"
import Join from "@/pages/Join/Join"
import ReportPage from "@/pages/Debrief/ReportPage"
import ReportsList from "@/pages/ReportsList/ReportsList"
import Session from "@/pages/Session/Session"
import SessionsList from "@/pages/SessionsList/SessionsList"
import NotFound from "@/pages/NotFound/NotFound"

function App() {
  /*
   * Mounted at the root, not inside the guard that reads it: Firebase answers
   * "who is signed in" asynchronously, and a guard that started the observer on
   * its own first render would answer "nobody" before the question was asked.
   * The join and session routes need it too — that is how a facilitator opening
   * their own session is told apart from a guest.
   */
  useEffect(startAuth, [])

  return (
    <>
      <Routes>
        <Route
          path={ROUTES.ROOT}
          element={
            <FacilitatorOnly>
              <CustomerList />
            </FacilitatorOnly>
          }
        />
        <Route
          path={ROUTES.CUSTOMER_DETAILS}
          element={
            <FacilitatorOnly>
              <CustomerDetails />
            </FacilitatorOnly>
          }
        />
        {/* The four nav destinations. All facilitator-only, and all built on
            reads that already exist — no new query and no rules change. */}
        <Route
          path={ROUTES.SESSIONS}
          element={
            <FacilitatorOnly>
              <SessionsList />
            </FacilitatorOnly>
          }
        />
        <Route
          path={ROUTES.DECK}
          element={
            <FacilitatorOnly>
              <DeckPage />
            </FacilitatorOnly>
          }
        />
        <Route
          path={ROUTES.REPORTS}
          element={
            <FacilitatorOnly>
              <ReportsList />
            </FacilitatorOnly>
          }
        />
        <Route
          path={ROUTES.ARCHIVE}
          element={
            <FacilitatorOnly>
              <ArchivePage />
            </FacilitatorOnly>
          }
        />
        <Route
          path={ROUTES.REPORT}
          element={
            <FacilitatorOnly>
              <ReportPage />
            </FacilitatorOnly>
          }
        />
        <Route path={ROUTES.JOIN} element={<Join />} />
        <Route path={ROUTES.SESSION} element={<Session />} />
        {/* Same deck as ROUTES.DECK, no AppShell: its nav offers facilitator-only
            destinations, and there is nowhere for a guest to open them to. */}
        <Route path={ROUTES.DECK_PREVIEW} element={<DeckPreviewPage />} />
        {/* Legacy: the public preview used to live at /deck/preview. Keep old
            shared links working by redirecting to its new home. */}
        <Route path="/deck/preview" element={<Navigate to={ROUTES.DECK_PREVIEW} replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ErrorToast />
    </>
  )
}

export default App
